export const LOGIN_SIG = 'LOGIN_SIG'
export const LOGIN_SIG_SUCCESS = 'LOGIN_SIG_SUCCESS'
export const LOGIN_SIG_FAIL = 'LOGIN_SIG_FAIL'


export const EXIBIR_DOC = 'EXIBIR_DOC'
export const EXIBIR_DOC_SUCCESS = 'EXIBIR_DOC_SUCCESS'
export const EXIBIR_DOC_FAIL = 'EXIBIR_DOC_FAIL'

export const ARQUIVO = 'ARQUIVO'
export const ARQUIVO_SUCCESS = 'ARQUIVO_SUCCESS'
export const ARQUIVO_FAIL = 'ARQUIVO_FAIL'

export const LIMPA_MSG = 'LIMPA_MSG'

export const SIG_CONTATAR = 'SIG_CONTATAR'
export const SIG_CONTATAR_SUCCESS = 'SIG_CONTATAR_SUCCESS'
export const SIG_CONTATAR_FAIL = 'SIG_CONTATAR_FAIL'

export const ADD_STATE = 'ADD_STATE'